import React, { useEffect, useState } from "react";

import { CProgress } from "@coreui/react";
import { useSelector } from "react-redux";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import Loading from "../../Loading";
import StatisticTrailFilters from "../../StatisticTrailFilters";

import "./styles.scss";

const AtividadeTurma = ({ id }) => {
  const token = useSelector(state => state.user.token);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const changeFilter = selected => {
    setLoading(true);
    setRoomId(selected.roomId);
    setGroupId(selected.groupId);
    setRegionId(selected.regionId);
    setSchoolId(selected.schoolId);

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      trail_id: id
    };

    axios
      .get(`${URL.api}statistics/trail_by_activities`, {
        params,
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resp => {
        setData(
          resp.data.data.map(activity => ({
            ...activity,
            executions: activity.executions.map(execution => ({
              ...execution,
              grade: execution.items.reduce((acc, item) => {
                if (item.final_grade !== null) {
                  return acc + parseFloat(item.final_grade);
                }

                return acc;
              }, null),
              time: execution.items.reduce((acc, item) => {
                const difference =
                  (new Date(item.end) - new Date(item.start)) / 1000;

                return acc + difference;
              }, null)
            }))
          }))
        );
        setLoading(false);
      });
  };

  return (
    <>
      <div className="layoutTabela">
        <div className="layoutTabelaComparacao flex-column w-100">
          <StatisticTrailFilters id={id} onChange={changeFilter} />
        </div>
        <div className="w-100">
          {loading ? (
            <div className="d-flex align-items-center justify-content-center w-100 p-5">
              <Loading />
            </div>
          ) : (
            <div className="w-100">
              <table className="table table-hover table-outline mb-0 d-none d-sm-table">
                <thead className="thead-light">
                  <tr>
                    <th>Atividade</th>
                    <th>Disciplina</th>
                    <th>Professor</th>
                    <th>Estudantes</th>
                    <th>% Conclusão</th>
                    <th>Tempo médio</th>
                    <th>Maior nota</th>
                    <th>Menor nota</th>
                    <th>Média</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(activity => {
                    const trulyExecutions = activity.executions.filter(
                      execution => execution.completion_percentage >= 100
                    );

                    const gradeExecutions = activity.executions.filter(
                      execution => execution.grade !== null
                    );

                    const trulyTimeExecutions = trulyExecutions.filter(
                      execution => execution.time !== null
                    );

                    const percentage =
                      activity.total_users === 0
                        ? 0
                        : (trulyExecutions.length / activity.total_users) * 100;

                    return (
                      <tr key={activity.id}>
                        <td>{activity.name}</td>
                        <td>{activity.discipline_name}</td>
                        <td>{activity.user_name}</td>
                        <td>{activity.total_users}</td>
                        <td>
                          <div className="clearfix">
                            <div className="float-left">
                              <strong>{percentage.toFixed(2)}%</strong>
                            </div>
                          </div>
                          <CProgress
                            className="progress-xs"
                            color={
                              percentage * 100 > 50
                                ? "success"
                                : percentage * 100 <= 50 &&
                                  percentage * 100 >= 30
                                ? "warning"
                                : "danger"
                            }
                            value={percentage * 100}
                          />
                        </td>
                        <td>
                          {trulyTimeExecutions.length > 0
                            ? (
                                trulyTimeExecutions.reduce(
                                  (acc, val) => acc + parseFloat(val.time),
                                  0
                                ) / trulyTimeExecutions.length
                              ).toFixed(2)
                            : "-"}
                        </td>
                        <td>
                          {gradeExecutions.length > 0
                            ? gradeExecutions
                                .reduce(
                                  (acc, val) =>
                                    Math.max(acc, parseFloat(val.grade)),
                                  0
                                )
                                .toFixed(2)
                            : "-"}
                        </td>
                        <td>
                          {gradeExecutions.length > 0
                            ? gradeExecutions
                                .reduce(
                                  (acc, val) =>
                                    Math.min(acc, parseFloat(val.grade)),
                                  10000
                                )
                                .toFixed(2)
                            : "-"}
                        </td>
                        <td>
                          {gradeExecutions.length > 0
                            ? (
                                gradeExecutions.reduce(
                                  (acc, val) => acc + parseFloat(val.grade),
                                  0
                                ) / gradeExecutions.length
                              ).toFixed(2)
                            : "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AtividadeTurma;
